// @ts-nocheck
import { User } from '@greenkub-fronts/shared/interface';
import styles from './avatar.module.scss';
import { profiles } from '../../../assets';
import cx from 'classnames';

export interface AvatarProps {
  user: Partial<User>;
  className?: string;
}

export function Avatar(props: AvatarProps) {
  const { user, className } = props;

  if (user && user.email) {
    const img = profiles.find((item) => item.includes(user?.email));

    if (img) {
      return (
        <img
          className={cx(styles['Avatar'], className)}
          src={img}
          alt="avatar"
        />
      );
    }
  }

  return (
    <p className={cx(styles['Avatar'], className)}>
      {typeof user?.firstName === 'string' && typeof user?.lastName === 'string'
        ? user.firstName.charAt(0).toUpperCase() + user.lastName.charAt(0).toUpperCase()
        : '?'
      }
    </p>
  );
}

export default Avatar;
